import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FrontSonda from '@gcloud-npm/next12.utils.front-sonda';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import Button from '@gcloud-npm/next12.components.button-m';
import Icon from '@gcloud-npm/next12.components.icon-n';
import { PHONE_COLORS, KIND, VIEW_OPTIONS, SCX_ROUTE } from './enums';

export { PHONE_COLORS, KIND, VIEW_OPTIONS };

/**
 * @name Call4Selling
 * @param {any} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */
const Call4Selling = ({
  forced900,
  applySam,
  activateCML,
  kind,
  taggingInfo,
  buttonProps,
  view,
  label,
  innerLabel,
  print900,
  className,
  textProps,
  innerLabelTextProps,
  phoneTextProps,
  children,
  iconProps,
  forceExternal,
}) => {
  const [isSCXLoaded, setIsSCXLoaded] = useState(0);
  const [virtual900, setVirtual900] = useState('');
  const [lastComunicated, setLastComunicated] = useState('');
  const myTaggingInfo = {
    componentName: 'Call4Selling',
    componentContent: kind,
    componentProduct: '',
    componentVariation: 'all',
    ...taggingInfo,
  };
  const get900 = () => {
    if (forced900) {
      return forced900;
    }
    return window.SCX.get900();
  };

  const checkAndSubscribeToSCX = () => {
    window.SCX?.onChange((data) => {
      if (kind === KIND.PHONE) {
        const phone = window.SCX?.get900();
        if (phone !== virtual900) {
          setVirtual900(window.SCX?.get900());
        }
      } else {
        window.SCX.setReactEnviroment();
      }
    });
    if (window && window.SCX) {
      setIsSCXLoaded(1);
    } else {
      document.addEventListener('SCX_CREATED', () => {
        setIsSCXLoaded(isSCXLoaded + 1);
      });
    }
  };

  const comunicate900Printed = (num900) => {
    if (lastComunicated !== num900) {
      setLastComunicated(num900);
      window.SCX.comunicate900Printed(num900);
    }
  };

  const handleClick = () => {
    if (window.SCX && window.SCX.processC2C) {
      window.SCX.launchModalC2C();
    } else {
      // Sonda esto
      const sonda = new FrontSonda({
        processName: 'launchModalC2C',
        context: null,
        filePath: 'call4SellingComponent',
      });
      sonda.warningMessage({
        info: 'No se ha podido lanzar la modal C2C',
      });
    }
  };

  useEffect(() => {
    const loadjs = require('loadjs');
    const scxRoute =
      process.env.NEXT_PUBLIC_ENV_NAME === 'prod'
        ? SCX_ROUTE.PROD
        : SCX_ROUTE.QA;

    // Si voy a necesitar scx.js, lo incluyo!
    if (
      ((kind === KIND.PHONE && !forced900) || kind === KIND.C2C) &&
      !window.SCX
    ) {
      loadjs(scxRoute, {
        success() {
          checkAndSubscribeToSCX();
        },
        async: true,
      });
    }

    if (
      applySam &&
      typeof window !== 'undefined' &&
      typeof window.IC !== 'undefined' &&
      typeof window.IC.evaluate === 'function'
    ) {
      if (typeof window.sa2mAction === 'undefined') {
        window.IC.evaluate(
          'SCX',
          () => {
            if (typeof window.sa2mAction === 'undefined') {
              window.sa2mAction = { 900: 'show', c2c: 'show' };
            }
          },
          () => {
            if (typeof window.sa2mAction === 'undefined') {
              window.sa2mAction = { 900: 'show', c2c: 'show' };
            }
          }
        );
      }
    }
    // checkAndSubscribeToSCX();
  }, []);

  if (typeof window !== 'undefined') {
    if (typeof window.SCX !== 'undefined') {
      if (kind === KIND.PHONE) {
        if (
          !virtual900 ||
          !window.SCX.CMNTimeTableValid() ||
          (applySam &&
            typeof window.sa2mAction !== 'undefined' &&
            window.sa2mAction['900'] === 'hide')
        ) {
          return null;
        }
        comunicate900Printed(get900());

        return (
          <>
            {view === VIEW_OPTIONS.BUTTON && label && (
              <Button
                className={`${className} call4selling call4selling-n call4Selling_button call4selling_phone`}
                label={print900 ? `${label} ${virtual900}` : `${label}`}
                href={`tel:${virtual900}`}
                taggingInfo={myTaggingInfo}
                forceExternal={forceExternal}
                {...buttonProps}
              />
            )}

            {view === VIEW_OPTIONS.PHONE && label && (
              <TextInfo text={label} {...textProps} />
            )}

            {view === VIEW_OPTIONS.PHONE && (
              <CustomLink
                href={`tel:${virtual900}`}
                className={`${className} call4selling call4selling-n call4selling_phone scx-telefono`}
                taggingInfo={myTaggingInfo}
                title={`${
                  innerLabel ? `${innerLabel} ` : 'Llamar gratis al '
                }${virtual900}`}
                ariaLabel={virtual900}
                forceExternal={forceExternal}
              >
                {innerLabel && (
                  <TextInfo text={`${innerLabel} `} {...innerLabelTextProps} />
                )}
                <TextInfo text={virtual900} {...phoneTextProps} />
                <Icon {...iconProps} />
              </CustomLink>
            )}
          </>
        );
      }
      if (
        kind === KIND.C2C &&
        (window.SCX.CMNTimeTableValid() || activateCML) &&
        !(
          applySam &&
          typeof window.sa2mAction !== 'undefined' &&
          window.sa2mAction.c2c === 'hide'
        )
      ) {
        return (
          <>
            {view === VIEW_OPTIONS.PHONE && (
              <CustomLink
                onClick={handleClick}
                className={`call4selling call4selling-n call4selling_c2c ${className}`}
                taggingInfo={myTaggingInfo}
                title="Te llamamos"
                ariaLabel="Te llamamos"
                forceExternal={forceExternal}
              >
                {children}
              </CustomLink>
            )}
            {view === VIEW_OPTIONS.BUTTON && (
              <Button
                className={`call4selling call4selling-n call4selling_c2c ${className}`}
                onClick={handleClick}
                taggingInfo={myTaggingInfo}
                forceExternal={forceExternal}
                {...buttonProps}
              />
            )}
          </>
        );
      }
      return null;
    }
  }
  return null;
};

Call4Selling.propTypes = {
  /**
   * {
   *  "info": "Activar activateCallMeLater (CML)",
   *  "kind": "playground",
   *  "beautifulName": "Call Me Later"
   * }
   */
  activateCML: PropTypes.bool,
  /**
   * {
   *  "info": "Activar acciones SAM",
   *  "kind": "both",
   *  "beautifulName": "SAM"
   * }
   */
  applySam: PropTypes.bool,
  /**
   * {
   *  "info": "Mostrar barra 900",
   *  "kind": "both",
   *  "beautifulName": "900"
   * }
   */
  print900: PropTypes.bool,
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
  /**
   * {
   *  "info": "Permite contribuir la infomación que será enviada a analítica tras la interacción (objeto para el taggeado)",
   *  "kind": "both",
   *  "beautifulName": "Propiedades tagueo"
   * }
   */
  taggingInfo: PropTypes.object,
  /**
   * {
   *  "info": "Definición de las propiedades para el TextInfo que precede al número de teléfono, POR DEFECTO es un span",
   *  "kind": "both",
   *  "beautifulName": "Propiedades botón"
   * }
   */
  textProps: PropTypes.object,
  /**
   * {
   *  "info": "Definición de las propiedades para el TextInfo que acompaña al número de teléfono, POR DEFECTO es un span",
   *  "kind": "both",
   *  "beautifulName": "Propiedades label"
   * }
   */
  innerLabelTextProps: PropTypes.object,
  /**
   * {
   *  "info": "Definición de las propiedades para el TextInfo que representa al número de teléfono, POR DEFECTO es un span",
   *  "kind": "both",
   *  "beautifulName": "Propiedades del texto del telefono"
   * }
   */
  phoneTextProps: PropTypes.object,
  /**
   * {
   *  "info": "Definición de las propiedades para el botón",
   *  "kind": "both",
   *  "beautifulName": "Propiedades telefono"
   * }
   */
  buttonProps: PropTypes.object,
  /**
   * {
   *  "info": "Definición de las propiedades para el icono",
   *  "kind": "both",
   *  "beautifulName": "Propiedades icono"
   * }
   */
  iconProps: PropTypes.object,
  /**
   * {
   *  "info": "Visibiliza el componente",
   *  "kind": "both",
   *  "beautifulName": "Visible"
   * }
   */
  view: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(Object.values(VIEW_OPTIONS)),
  ]),
  /**
   * {
   *  "info": "número 900 'a fuego' que se quiere pintar",
   *  "kind": "both",
   *  "beautifulName": "forced900"
   * }
   */
  forced900: PropTypes.string,
  /**
   * {
   *  "info": "tipo de C4S",
   *  "kind": "both",
   *  "beautifulName": "kind"
   * }
   */
  kind: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(Object.values(KIND)),
  ]),
  forceExternal: PropTypes.bool,
};

Call4Selling.defaultProps = {
  className: '',
  applySam: true,
  print900: true,
  view: VIEW_OPTIONS.PHONE,
  kind: KIND.PHONE,
  activateCML: false,
  textProps: {},
  innerLabelTextProps: {},
  phoneTextProps: {},
  buttonProps: {},
  forced900: '',
  taggingInfo: {},
  iconProps: {},
  forceExternal: false,
};

export default Call4Selling;
